import { ActionIcon, Box, Button, Group, Input, Navbar, Switch, Tabs } from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconBooks, IconVariable, IconX, IconMessage, IconList } from '@tabler/icons';
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { LinksGroup } from '../../components/NavbarLinksGroup/NavbarLinksGroup';
import { ScriptContext } from "../context/ScriptContext";
import { mockdata } from './menuData';
import './navbar.css';
import { useStyles } from './style';
import { AppSettingsContext } from '../context/AppSettingsContext';
import ModalCustomNode from '../ModalCustomNode';
import { compareAppVersions } from '../../compareAppVersions';
import Chat from '../Chat';

const NavbarNested = (props) => {
    const text = useRef('')
    const ref = useRef(null)
    const { settings } = useContext(AppSettingsContext)
    const scriptContext = useContext(ScriptContext);
    const { classes } = useStyles();
    const customNodeRef = useRef(null);
    const [navItem, setNavItem] = useState(mockdata.map(item => ({ ...item, links: item.links.filter(link => link.data.version <= settings.autoVersion) })));
    const [show, setShow] = useState(false)
    const [filter, setFilter] = useState({ search: '', page: 1, limit: 9 });
    const [lastPage, setLastPage] = useState(1);
    const [category, setCategory] = useState('-1')
    const [chatMode, setChatMode] = useState(false)
    const handleOpenNode = (index) => {
        const newState = [...navItem]
        newState[index].initiallyOpened = !newState[index].initiallyOpened
        setNavItem(newState)
    }

    useEffect(() => {
        setNavItem(mockdata.map(item => ({ ...item, links: item.links.filter(link => {
            console.log(link.data.appVersion);
            if (link.data.appVersion) {
                const appVersion = window.api?.APP_VERSION || localStorage.getItem('appVersion') || ''
                return compareAppVersions(appVersion, link.data.appVersion) >= 0
            }
            return link.data.version <= settings.autoVersion
        }) })))
    },[settings.autoVersion])

    const links = useMemo(
        () => navItem.map(
            (item, index) => <LinksGroup {...item}
                key={item.label}
                index={index}
                handleOpenNode={handleOpenNode}
                handleDbClick={props.handleDbClick}
            />
    ), [navItem]);
    const form = useForm({
        initialValues: { name: scriptContext.scriptName ?? '' },

        // functions will be used to validate values at corresponding key
        validate: {
            name: (value) => (value.length < 1
                ? 'Name must have at least 1 letters'
                : value.length > 255
                    ? 'Name is too long'
                    : null
            ),
        },
    });

    useEffect(() => {
        form.setValues({
            name: scriptContext.scriptName ?? "",
        })
    }, [scriptContext])

    const handleOpenAllNodes = (event) => {
        const isChecked = event.target.checked;

        const newData = navItem.map(item => ({
            ...item,
            initiallyOpened: isChecked
        }));

        if (customNodeRef.current) {
            customNodeRef.current.setOpenCollapse(isChecked);
        }

        setNavItem(newData);
    };


   const handleClearInput = () => {
        text.current.value = ""
        setNavItem(mockdata.map(item => ({ ...item, links: item.links.filter(link => link.data.version <= settings.autoVersion) })))
   }

   const rightSection = (<ActionIcon onClick={handleClearInput} radius="xl"><IconX size="1rem"/></ActionIcon>)

   const handleFilter = (e) => {
        const text = e.target.value
        const newData = [...mockdata].map(item => ({
            ...item,
            links: item.links.filter(link => {
                console.log(link.data.appVersion);
                if (link.data.appVersion) {
                    const appVersion = window.api?.APP_VERSION || localStorage.getItem('appVersion') || ''
                    return compareAppVersions(appVersion, link.data.appVersion) >= 0
                }
                return link.data.version <= settings.autoVersion
            })
        }))
        let node = newData.map((element) => {
            if (text.toLowerCase() === "") {
                return element
            } else {
                return {...element, links: element.links.filter((nodeLink) =>
                    nodeLink.data.label.toLowerCase().includes(text.toLowerCase())
                )}
            }
        })
        setNavItem(node)
   }

    return (
        <>
            <Navbar
                width={{ sm: 360 }}
                p="md"
                className={classes.navbar}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100vh',
                    maxHeight: '100vh',
                    minHeight: 0,
                    overflow: 'hidden',
                    flexShrink: 0,
                }}
            >
                <Tabs
                    value={chatMode ? 'ai' : 'manual'}
                    onTabChange={(v) => setChatMode(v === 'ai')}
                    variant="outline"
                    keepMounted
                    styles={{
                        root: {
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: 0,
                        },
                    }}
                >
                    <Navbar.Section className={classes.header} sx={{ flexShrink: 0 }}>
                        <Tabs.List grow mb="sm">
                            <Tabs.Tab
                                value="ai"
                                style={{ padding: "0 !important" }}
                                icon={<IconMessage size={16} stroke={1.5} />}
                                title="Generate script with AI"
                            >
                                AI
                            </Tabs.Tab>
                            <Tabs.Tab
                                value="manual"
                                icon={<IconList size={16} stroke={1.5} />}
                                title="Browse and add nodes manually"
                            >
                                Manual
                            </Tabs.Tab>
                        </Tabs.List>
                        {!chatMode && (
                            <Group style={{ justifyContent: 'center', alignItems: 'center' }} spacing="xs">
                                <Input
                                    ref={text}
                                    placeholder="Search"
                                    style={{ width: 190 }}
                                    rightSection={rightSection}
                                    onChange={handleFilter}
                                />
                                <Switch
                                    size='sm'
                                    className='d-flex'
                                    ref={ref}
                                    checked={navItem.some((item) => item.initiallyOpened)}
                                    onChange={handleOpenAllNodes}
                                />
                            </Group>
                        )}
                        {
                            !chatMode && (
                                <div style={{ marginTop: '20px'}}>
                                    <Group position="apart" align="center">
                                        <Button
                                            leftIcon={<IconVariable size={14} />}
                                            variant="default"
                                            onClick={props.handleShowVariables}
                                        >
                                            Variables
                                        </Button>
                                        <Button
                                            leftIcon={<IconBooks stroke={1.25} size={14}/>}
                                            variant="default"
                                            onClick={() => setShow(true)}
                                        >
                                            Library custom node
                                        </Button>
                                    </Group>
                                </div>
                            )
                        }
                    </Navbar.Section>
                    <Navbar.Section
                        grow
                        className={classes.links}
                        sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}
                    >
                        <Tabs.Panel
                            value="manual"
                            pt="xs"
                            sx={{
                                flex: 1,
                                minHeight: 0,
                                overflow: 'hidden',
                                position: 'relative',
                            }}
                        >
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    overflowY: 'auto',
                                    overflowX: 'hidden',
                                    WebkitOverflowScrolling: 'touch',
                                }}
                            >
                                <div className={classes.linksInner}>
                                    {links}
                                </div>
                            </Box>
                        </Tabs.Panel>
                        <Tabs.Panel value="ai" p={0} sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
                            <Box sx={{ height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
                                <Chat />
                            </Box>
                        </Tabs.Panel>
                    </Navbar.Section>
                </Tabs>
                <Navbar.Section className={classes.footer}>
                </Navbar.Section>
            </Navbar>
            {show && <ModalCustomNode
                show={show}
                setShow={setShow}
                props={props}
                filter={filter}
                setFilter={setFilter}
                lastPage={lastPage}
                setLastPage={setLastPage}
                category={category}
                setCategory={setCategory}
            />}
        </>
    );
}

export default NavbarNested;